export default function CTASection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative w-full overflow-hidden">
      {/* Full bleed image */}
      <div className="relative h-80 md:h-[440px] flex items-center">
        <img
          src="https://public.readdy.ai/ai/img_res/37966e00b7e8f38bdd048c9eb5442f5a.jpg"
          alt="Balıkçı Zafer Lezzetleri"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1a3a4a]/90 via-[#1a3a4a]/70 to-transparent"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-12 w-full">
          <div className="max-w-xl">
            {/* Label */}
            <div className="flex items-center gap-3 mb-5">
              <span className="w-8 h-px bg-[#e8734a]"></span>
              <span className="text-[#e8734a] text-xs font-bold tracking-widest uppercase">Rezervasyon</span>
            </div>

            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Masanızı Şimdiden<br />
              <span className="text-[#e8734a]">Ayırtın</span>
            </h2>
            <p className="text-white/70 text-base mb-8 leading-relaxed">
              Özel günler, aile yemekleri veya iş yemekleri için Balıkçı Zafer'de yerinizi ayırtın. Taze deniz lezzetleri ve sıcak atmosfer sizi bekliyor.
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => handleScroll("#iletisim")}
                className="inline-flex items-center justify-center gap-2 bg-[#e8734a] text-white px-8 py-4 rounded-full font-bold text-sm hover:bg-[#cf6340] transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-calendar-check-line"></i>
                Rezervasyon Yap
              </button>
              <button
                onClick={() => handleScroll("#menu")}
                className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm text-white border border-white/25 px-8 py-4 rounded-full font-bold text-sm hover:bg-white/20 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-restaurant-2-line"></i>
                Menüyü Gör
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom info strip */}
      <div className="bg-[#1a3a4a] py-5">
        <div className="max-w-7xl mx-auto px-4 md:px-12 flex flex-wrap items-center justify-center md:justify-between gap-4">
          {[
            { icon: "ri-time-line", text: "Her gün 11:00 – 22:00" },
            { icon: "ri-map-pin-line", text: "Aliağa, İzmir" },
            { icon: "ri-phone-line", text: "+90 (232) 000 00 00" },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2 text-white/70 text-sm">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} text-[#e8734a] text-base`}></i>
              </div>
              {item.text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
